import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DoneIcon from 'material-ui/svg-icons/action/done';
import CancelledIcon from 'material-ui/svg-icons/content/clear';
import WaitingIcon from 'material-ui/svg-icons/action/schedule';
import SpotIcon from 'material-ui/svg-icons/image/lens';
import CircleIcon from 'material-ui/svg-icons/image/timelapse';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
import { formatName } from '../../utils/StringUtils';

class CourseEnrolmentTableRow extends Component {

    render() {
        const { row, children, actions, ...others } = this.props;
        const active = !row.userDeleted && !row.userArchived;

        let iconGroup = [];
        if (row.isAssigned) {
            if (row.isMandatory) {
                if(row.canRetake) {
                    iconGroup.push(<CircleIcon className="icon-small-td" color={statusColours.mandatory} key="mandatory"/>);
                } else {
                    iconGroup.push(<SpotIcon className="icon-small-td" color={statusColours.mandatory} key="mandatory"/>);
                }
            } else {
                if(row.canRetake) {
                    iconGroup.push(<CircleIcon className="icon-small-td" color={statusColours.optional} key="optional"/>);
                } else {
                    iconGroup.push(<SpotIcon className="icon-small-td" color={statusColours.optional} key="optional"/>);
                }
            }
        }

        let status = '';

        switch(row.status) {

            case 'cancelled':
                status = <CancelledIcon color={active ? statusColours.medium : statusColours.waiting}/>;
                break;

            case 'waiting':
                status = <WaitingIcon color={active ? statusColours.medium : statusColours.waiting}/>;
                break;

            case 'completed':
                status = <DoneIcon color={active ? statusColours.primary : statusColours.waiting}/>;
                break;

            default:
                break;

        }

        const dateEnrolled = (row.dateStart) ? new Date(row.dateStart).toLocaleString('en-GB', DateStyles.short) : null;
        const dateCompleted = (row.dateCompleted) ? new Date(row.dateCompleted).toLocaleString('en-GB', DateStyles.short) : null;
        const score = (row.score) ? row.score : null;
        const infoLink = `/dashboard/course/enrolment/${row.id}`;
        const userLink  = `/dashboard/user/${row.userId}`;

        const rowActions = !active ? [] : [
            <IconButton key="edit" onClick={() => actions.onEdit([row.id])} disabled={this.props.row.loading}>
                <EditIcon color={statusColours.medium} />
            </IconButton>,
        ];
        if (this.context.auth.isAdmin()) {
            rowActions.push(
                <IconButton key="delete" onClick={() => actions.onDelete('confirmDelete', row.id)} disabled={this.props.row.loading}>
                    <DeleteIcon color={statusColours.medium} />
                </IconButton>
            );
        }

        return (
            <TableRow {...others} selectable={active}>
                { children && children[0] }

                <TableRowColumn><Link to={infoLink}>{dateEnrolled} {iconGroup}</Link></TableRowColumn>
                <TableRowColumn>
                    {active
                        ? <Link to={userLink}>{formatName(row)}</Link>
                        : <span style={{color: statusColours.waiting}} title={!!row.userDeleted ? "Deleted user" : "Archived user"}>{formatName(row)}</span>
                    }
                </TableRowColumn>
                <TableRowColumn><Link to={infoLink}>{dateCompleted}</Link></TableRowColumn>
                <TableRowColumn className="tbl-td-number"><Link to={infoLink}>{score}</Link></TableRowColumn>
                <TableRowColumn className="tbl-td-icon">{status}</TableRowColumn>
                <TableRowColumn className="tbl-td-actions">{rowActions}</TableRowColumn>
            </TableRow>
        );
    }
}

CourseEnrolmentTableRow.contextTypes = {
    auth: PropTypes.object
};

export default CourseEnrolmentTableRow;
